import { styled } from "styled-components";
import IconButton from "@mui/material/IconButton";
import Select from "@mui/material/Select";
import FormControl from "@mui/material/FormControl";
import { theme as defaultTheme } from "@mindlercare/ui-web";

export interface MarginType {
  marginleft?: string;
  marginright?: string;
}

export const Container = styled.div`
  background-color: white;
  position: relative;
  margin-bottom: 24px;
  @media (max-width: 759px) {
    height: 84px;
  }
  #calendar-prev {
    padding: 8px;
  }
  #calendar-next {
    padding-left: 8px;
  }
`;

export const ToolbarContainer = styled.div`
  display: flex;
  justify-content: space-between;
  vertical-align: middle;
`;

export const ToolbarInner = styled.div`
  display: flex;
  gap: 8px;
`;

export const ToolbarInnerItem = styled.div`
  display: flex;
  align-items: center;
`;

export const InnerContainer = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  @media (max-width: 759px) {
    flex-direction: column;
  }
`;

export const Icon = styled(IconButton)<MarginType>`
  height: 40px;
  width: 40px;
  display: flex;
  margin-left: ${(props) => (props.marginleft ? "20px" : null)};
  margin-right: ${(props) => (props.marginright ? "20px" : null)};
  justify-content: center;
  color: ${defaultTheme.COLORS.GRAY_BLACK};
  align-items: center;
  @media (max-width: 759px) {
    width: 20px;
    padding: 0;
    height: 20px;
  }
  &:hover {
    background-color: ${defaultTheme.COLORS.GRAY_X_LIGHT};
  }
`;

export const WeekTextContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`;

export const NavigationContainer = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
  @media (max-width: 759px) {
    p {
      margin: 3px 0 0 0;
    }
  }
`;

export const NavigationLeft = styled.div`
  display: flex;
  justify-content: space-between;
  flex: 0 0 55%;
  position: relative;
`;

export const SelectButton = styled(Select)`
  font-size: ${defaultTheme.FONT.SIZE.SMALL_MEDIUM};
`;

export const FormControlComponent = styled(FormControl)`
  width: 120px;
  height: 17px;
  padding: 1px;
  margin-left: ${defaultTheme.MARGIN.SM};
  .MuiOutlinedInput-input {
    padding: 5px 15px;
  }
  &:first-of-type {
    padding-right: 8px;
  }
`;

export const NavigateTodayButton = styled.button`
  margin-right: ${defaultTheme.MARGIN.SM};
  text-transform: none;
  border-radius: 100px;
  background-color: transparent;
  border: 1px solid ${defaultTheme.COLORS.MIDDLE_GREY};
  height: 36px;
  padding: 0 3px;
  cursor: pointer;
  font-size: ${({ theme }) => defaultTheme.FONT.SIZE.STANDARD};
  &:hover {
    background-color: ${({ theme }) =>
      defaultTheme.COLORS.MEDIUM_GREEN_OPACITY};
    transition: ${({ theme }) => defaultTheme.TRANSITION.STANDARD_TRANSITION};
    border: 1px solid ${({ theme }) => defaultTheme.COLORS.MEDIUM_GREEN};
  }
`;

export const WeekContainer = styled.div`
  display: flex;
  align-items: center;
`;
